import { Route, Navigate, Outlet } from "react-router";
import type { ReactElement } from "react";
import Layout from "./Layout";
import ActoRoutes from "./routes.config";
import { createAuthRouter, ProtectedRoute, useAuthContext } from "@acto/web-common/auth";
import WelcomePage from "@acto/taskpane/core/pages/WelcomePage";
import { TenantSettingsProvider } from "@acto/taskpane/core/contexts/TenantSettingsContext";
import { ViewerProvider } from "@acto/taskpane/core/contexts/ViewerContext";
import { AuthenticatedLocaleProvider } from "@acto/taskpane/core/contexts/UserLocaleContext";
import { createFieldSalesTwoRoutes } from "@acto/taskpane/field-sales-2/routes";

const RootRedirect = () => {
  const { isAuthenticated } = useAuthContext();
  return <Navigate to={isAuthenticated ? ActoRoutes.HOME : ActoRoutes.WELCOME} replace />;
};

function buildRoutes(): ReactElement {
  return (
    <Route element={<Layout />}>
      <Route path="/" element={<RootRedirect />} />

      <Route path={ActoRoutes.WELCOME} element={<WelcomePage />} />

      <Route element={<ProtectedRoute />}>
        <Route
          element={
            <ViewerProvider>
              <AuthenticatedLocaleProvider>
                <TenantSettingsProvider>
                  <Outlet />
                </TenantSettingsProvider>
              </AuthenticatedLocaleProvider>
            </ViewerProvider>
          }
        >
          {createFieldSalesTwoRoutes()}
        </Route>
      </Route>

      <Route path={ActoRoutes.UNAUTHORIZED} element={<div>Not Authorized</div>} />
    </Route>
  );
}

interface TaskpaneRouterOptions {
  persistSessionInFrame: boolean;
}

export function createTaskpaneRouter({ persistSessionInFrame }: TaskpaneRouterOptions) {
  return createAuthRouter(buildRoutes(), {
    urlStrategy: "hash",
    notFoundRedirectRoute: ActoRoutes.HOME,
    unauthorizedPageRedirectUrl: ActoRoutes.UNAUTHORIZED,
    welcomePageRoute: ActoRoutes.WELCOME,
    frontegg: {
      baseUrl: import.meta.env.VITE_FRONTEGG_BASE_URL,
      clientId: import.meta.env.VITE_PUBLIC_FRONTEGG_CLIENT_ID,
    },
    persistSessionInFrame,
  });
}
